export const Flavour = {
  VENUE_SEARCH: "venue-search",
  CONCIERGE: "concierge",
  VENUE_FINDER_VERT: "venue-finder-vert",
  VENUE_FINDER: "venue-finder",
  WHITE_LABEL: "white-label",
};

export const venueFinderFlavours = [
  Flavour.VENUE_FINDER,
  Flavour.WHITE_LABEL,
  Flavour.VENUE_FINDER_VERT,
];
